import { formAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  container: defineStyle({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'stretch',
  }),
  requiredIndicator: defineStyle({}),
  helperText: defineStyle({
    color: 'presets.neutral.60',
    fontSize: '10px',
    fontWeight: '600',
    margin: '0',
  }),
})

export const formTheme = defineMultiStyleConfig({
  baseStyle,
})
